import { useEffect as c, useRef as s, useCallback as d } from "react";
import { addInstruction as i, addTool as o, addContext as p } from "../global-state.js";
function h(e) {
  return c(() => {
    const r = i(e);
    return () => r();
  }, [e.instruction]);
}
function C(e) {
  const r = s(e.handler);
  r.current = e.handler;
  const n = s(e.render);
  n.current = e.render;
  const t = !!e.render;
  return c(() => {
    const a = o({
      name: e.name,
      description: e.description,
      requestSchema: e.requestSchema,
      responseSchema: e.responseSchema,
      handler: async (u) => r.current(u),
      render: t ? (u) => n.current?.(u) : void 0
    });
    return () => a();
  }, [e.name, e.description, e.requestSchema, e.responseSchema, t]);
}
function S(e) {
  const r = s(e);
  r.current = e;
  const n = d(() => typeof r.current.value == "function" ? r.current.value() : r.current.value, []);
  return c(() => {
    const t = p({
      description: e.description,
      value: n
    });
    return () => t();
  }, [e.description]);
}
export {
  S as useCopilotContext,
  h as useCopilotInstruction,
  C as useCopilotTool
};
